import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import {
  IImageFile as IImageFile,
  IOrganisationImage as IOrganisationImage,
} from 'src/app/interfaces/organisation-image';
import { OrganisationImageApiService } from 'src/modules/role/organisation-admin/services/organisation-image-api-service';
import { OrganisationImageDataSource } from 'src/modules/role/organisation-admin/services/organisation-image-data-source';
import { Subscription } from 'rxjs';
import { AddFiles } from 'src/modules/directives/components/add-files/component';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { ImagesService } from 'src/app/services/images.service';

@Component({
    selector: 'carousel-image-add-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CarouselImagesAdd implements OnInit, OnDestroy {
  public loading: boolean;
  public OrganisationImages: IOrganisationImage[];

  public selectedImage: IOrganisationImage;
  public selectedImages: any[] = [];
  public CompanyId: number;
  public carouselImageIds: number[];
  DataSource: OrganisationImageDataSource | null;
  private Subscriptions: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    protected OrganisationImageApi: OrganisationImageApiService,
    protected dialogRef: MatDialogRef<CarouselImagesAdd>,
    protected commonFunctionService: CommonFunctionService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private imagesService: ImagesService
  ) {}
  public imageUrl: string = `${this.commonFunctionService.findApiUrl(
    this.data.role
  )}/${this.data.role}/`;

  ngOnInit() {
    this.DataSource = this.OrganisationImageApi.getDataSource(
      this.data.role,
      this.data.organisationId
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (OrganisationImages: IOrganisationImage[]) => {
          this.CompanyId = OrganisationImages[0]?.company_id || null;
          this.OrganisationImages = OrganisationImages.filter(
            (OrganisationImage) => {
              const matchingImages = this.data.Carousel.filter(
                (image) => image.company_image_id === OrganisationImage.id
              );
              return matchingImages.length < 1;
            }
          ).map((image) => {
            return {
              file_name_encoded: `${this.imageUrl}${
                this.CompanyId
              }/thumbnail/${encodeURI(image.file_name)}`,
              ...image,
            };
          });
        }
      )
    );

    this.Subscriptions.push(
      this.DataSource.loading.subscribe(
        (loading: boolean) => (this.loading = loading)
      )
    );

    this.DataSource.load();
  }

  public selectImage(OrganisationImage: IOrganisationImage) {
    if (this.selectedImages.includes(OrganisationImage)) {
      this.selectedImages = this.selectedImages.filter((value) => {
        return value !== OrganisationImage;
      });
    } else {
      this.selectedImages.push(OrganisationImage);
    }
  }

  public addNewImage() {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.data = { allowMultpleUpload: false };
    this.dialog
      .open(AddFiles, config)
      .afterClosed()
      .subscribe(({ files }: { files: IImageFile[] }) => {
        if (files) {
          const items = files.map((file) => {
            const { name: file_title } = file;
            return {
              id: null,
              file_title,
              file,
              company_id: this.CompanyId,
            };
          });

          this.DataSource.save(items);
        }
      });
  }

  public addImage() {
    this.dialogRef.close(this.selectedImages);
  }

  public getImageUrl(image) {
    return this.imagesService.getImageUrl(image);
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
